import React from "react";

import AuthenticationService from "./AuthenticationService";
import { StadePdaToken } from "./legacyAuthModel";

export type LegacyAuthState = {
  /**
   * Instance of `AuthenticationService<StadePdaToken>`.
   */
  authenticationService: AuthenticationService<StadePdaToken>;
  /**
   * The current city ID.
   */
  cityId?: string;
  /**
   * Flag to figure out if the user is logged in or not.
   */
  loggedIn: boolean;
  /**
   * Wrapper around `AuthenticationService<StadePdaToken>["cardLogin"]`.
   *
   * @param matricule - The matricule of the agent.
   * @param pinCode - The pin code of the agent.
   * @param deviceId - The NFC device ID.
   * @param cardUid - The NFC card ID.
   * @param keepSessionOpen - The flag to keep the session open or not.
   */
  login(
    matricule: string,
    pinCode: string,
    deviceId: string,
    cardUid: string,
    keepSessionOpen: "0" | "1"
  ): Promise<string>;
  /**
   * Wrapper around `AuthenticationService<StadePdaToken>["logout"]`.
   *
   * @param mode - The logout mode, `"soft"` means keep the user credentials,
   * `"hard"` means remove the user credentials.
   */
  logout(mode?: "soft" | "hard"): void;
  /**
   * Token needed to access the StaDe API.
   */
  token?: string;
  createAccountUrl?: Function;
};

export const LegacyAuthContext = React.createContext<
  LegacyAuthState | undefined
>(undefined);

export default LegacyAuthContext;
